export default __webpack_public_path__ + "static/logo-sbb-63c50d01b0edb66c4c30d42828442a13.png";